module.exports = __webpack_public_path__ + "img/checklist-button-bars.cab733ad.png";